import * as React from "react";

import { Icon } from "../../Icons/Icon";

import { Circle, PositionAdjustBlock } from "./Arrows.styles";

export function ArrowRight(): JSX.Element {
    return (
        <Circle>
            <PositionAdjustBlock>
                <Icon name="ArrowCRightIcon" size={34} />
            </PositionAdjustBlock>
        </Circle>
    );
}
